import React from 'react'

export default props => (
	<div style={{ display: 'flex', overflowX: 'auto' }}>
	    <table className='table table-bordered table-striped dataTable'>
			{props.children}
		</table>
	</div>
)
